import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";
import ObjectValidationPanel from "./Panel";

class ObjectValidationPane extends React.Component {
    render() {
        return <div className="flex flex-col overflow-hidden w-1/2 flex-1">
            <div
                className="px-4 py-3 bg-white border-t border-b border-slate-400 ">
                <h3 className="text-2xl font-bold">
                    <FontAwesomeIcon icon={faListCheck} className="mr-2"/>
                    Object Validation
                </h3>
                <span className="text-sm text-slate-600">Validate if objects appear in this image or not.</span>
            </div>
            <div className="bg-slate-100 overflow-y-auto" id="assignments">
                <ObjectValidationPanel checkChanged={this.props.checkChanged}/>
            </div>
        </div>;
    }
}

export default ObjectValidationPane;